import React from 'react'
import cn from 'classnames'
import { Field, useFormikContext } from 'formik'
import ValidationErrorMessage from './ValidationErrorMessage'

export default function Input({
    name,
    className,
    type = 'text',
    label,
    validate,
    imgSrc,
    onChange = () => {},
    component = 'input',
    optional = false,
    help,
    icon,
    ...attributes
}) {
    const { errors, touched, setFieldValue } = useFormikContext()
    const hasError = errors[name] && touched[name]

    React.useEffect(() => {
        if (attributes.value !== undefined) setFieldValue(name, attributes.value)
        if (typeof attributes.index === 'number') setFieldValue(name, 0)
    }, [attributes.index, attributes.value, name, setFieldValue])

    return (
        <div className="field">
            {label && (
                <label htmlFor={name} className="label">
                    <div className="columns is-vcentered">
                        {imgSrc && (
                            <div className="column is-narrow">
                                <img src={imgSrc} width="50" alt="alt" />
                            </div>
                        )}

                        <div className="column">
                            {label} {optional && <span className="form-hint">(не обязательно)</span>}
                        </div>
                    </div>
                </label>
            )}

            <div className={cn('control', { 'has-icons-left': icon })}>
                <Field
                    onChange={(event) => {
                        setFieldValue(name, event.target.value)
                        onChange(event.target.value)
                    }}
                    className={cn('input is-fullwidth', className, { 'is-danger': hasError })}
                    type={type}
                    name={name}
                    id={name}
                    component={component}
                    validate={validate}
                    {...attributes}
                />

                {icon && (
                    <span className="icon is-left">
                        <ion-icon name={icon} />
                    </span>
                )}
            </div>

            <ValidationErrorMessage name={name} />

            {help && !hasError && <p className="help">{help}</p>}
        </div>
    )
}
